<template>
  <v-dialog
    v-model="dialog"
    max-width="900px"
    :fullscreen="$vuetify.breakpoint.width<900"
    transition="dialog-transition-x"
    scrollable    
  >
    <v-card >
      <v-toolbar color="primary lighten-2">
        <span class="subheading white--text">Galeria de Fotos del Juramento</span>
        <v-spacer></v-spacer>
        <v-btn icon flat dark @click="cerrar">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        
     
      <div v-for="(juramento,id) in juramentosConFotos" :key="id">
        <v-subheader>{{juramento.nombre}} - {{textDate(juramento.fechaHora)}} - {{juramento.lugarJuramento}}</v-subheader>
        <v-container grid-list-xs fluid v-viewer>
          <v-layout row wrap>
            <v-flex   :xs6="$vuetify.breakpoint.width<900" :xs4="$vuetify.breakpoint.width>900" v-for="(foto, index) in juramento.fotosJuramento" :key="index">
              <v-card flat tile>
                <img :src="doc_url+foto" alt height="150px" width="100%" />
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
       </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    juramentos: {
      type: Array,
      default: [
          {
              nombre:'qwe',
              lugarJuramento:'a',
              fotosJuramento:[]
          }
      ]
    }
  },
  computed: {
     juramentosConFotos: function() {
       return this.juramentos.filter(function(u) {
         return u.fotosJuramento.length>0
     });
   },
   doc_url() {
      return this.$docUrl;
    }
  },
  methods: {
    cerrar() {
      this.$emit("cerrarGaleria");
    },
    textDate(date) {
      if (!date) return null;
      const [dates, hours] = date.split(" ");
      if (date.indexOf("-") > 0) {
        const [year, month, day] = dates.split("-");
        return `${day}/${month}/${year}`;
      }
      return date;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Juramento/GaleriaFotos.vue